import React from 'react';
import { Lightbulb, Target, Sparkles, Clock3 } from 'lucide-react';

const tips = [
  {
    icon: Target,
    title: 'Be Specific',
    description: "Focus on your most relevant skills and achievements for the job you're targeting."
  },
  {
    icon: Clock3,
    title: 'Keep it Concise',
    description: 'Aim for 3-5 impactful sentences that highlight your unique value proposition.'
  },
  {
    icon: Sparkles,
    title: 'Show Impact',
    description: 'Include quantifiable achievements and specific examples of your contributions.'
  },
  {
    icon: Lightbulb,
    title: 'Keywords Matter',
    description: 'Include relevant industry keywords to help your resume pass ATS systems.'
  }
];

interface TipProps {
  icon: typeof Target;
  title: string;
  description: string;
}

function Tip({ icon: Icon, title, description }: TipProps) {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0">
        <Icon className="h-5 w-5 text-blue-600" />
      </div>
      <div>
        <h4 className="text-sm font-medium text-blue-900">{title}</h4>
        <p className="text-sm text-blue-700">{description}</p>
      </div>
    </div>
  );
}

export default function SummaryTips() {
  return (
    <div className="bg-blue-50 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-blue-900 mb-4">Writing Tips</h3>
      <div className="space-y-4">
        {tips.map((tip, index) => (
          <Tip key={index} {...tip} />
        ))}
      </div>
    </div>
  );
}